import React from 'react';
import { parseHotkey } from 'is-hotkey';
import { IS_MAC } from '../../../../../helpers/BrowserHelpers';
var CODES = {
  alt: IS_MAC ? '⌥' : 'Alt',
  ctrl: IS_MAC ? '⌃' : 'Ctrl',
  meta: IS_MAC ? '⌘' : 'Ctrl',
  shift: IS_MAC ? '⇧' : 'Shift',
  8: '⌫',
  9: '⇥',
  13: '⏎',
  19: 'pause',
  20: '⇪',
  27: 'ESC',
  32: 'Space',
  33: 'Page up',
  34: 'Page down',
  35: 'End',
  36: 'Home',
  37: '←',
  38: '↑',
  39: '→',
  40: '↓',
  45: 'Insert',
  46: 'Delete',
  144: 'Numlock',
  145: 'Scroll lock',
  186: ';',
  187: '=',
  188: ',',
  189: '-',
  190: '.',
  191: '/',
  192: '`',
  219: '[',
  220: '\\',
  221: ']',
  222: "'"
};

function Key(_ref) {
  var children = _ref.children;
  return React.createElement("div", {
    className: "margin-left-smaller padding-smaller shade-20 background-shade-50 radius-normal center-text",
    style: {
      minWidth: 24,
      lineHeight: '16px'
    }
  }, children);
}

function ToolbarShortcut(_ref2) {
  var shortcut = _ref2.shortcut;
  if (!shortcut) return false;
  var keys = parseHotkey(shortcut);
  return React.createElement("div", {
    className: "font-size-small line-height-large shade-30 flexbox flexbox-align-center font-weight-medium"
  }, React.createElement("div", {
    className: "margin-right-smaller"
  }, "Shortcut:"), React.createElement("div", {
    className: "flexbox flexbox-align-center"
  }, keys.ctrlKey && React.createElement(Key, null, CODES.ctrl), keys.metaKey && React.createElement(Key, null, CODES.meta), keys.shiftKey && React.createElement(Key, null, CODES.shift), keys.altKey && React.createElement(Key, null, CODES.alt), keys.which && React.createElement(Key, null, CODES[keys.which] || String.fromCharCode(keys.which))));
}

export default React.memo(ToolbarShortcut);